/* This is generated code, don't alter */
var IfcOccupantTypeEnum;
(function (IfcOccupantTypeEnum) {
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["ASSIGNEE"] = 0] = "ASSIGNEE";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["ASSIGNOR"] = 1] = "ASSIGNOR";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["LESSEE"] = 2] = "LESSEE";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["LESSOR"] = 3] = "LESSOR";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["LETTINGAGENT"] = 4] = "LETTINGAGENT";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["OWNER"] = 5] = "OWNER";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["TENANT"] = 6] = "TENANT";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["USERDEFINED"] = 7] = "USERDEFINED";
    IfcOccupantTypeEnum[IfcOccupantTypeEnum["NOTDEFINED"] = 8] = "NOTDEFINED";
})(IfcOccupantTypeEnum || (IfcOccupantTypeEnum = {}));
const IfcOccupantTypeEnumCount = 9;
export { IfcOccupantTypeEnum, IfcOccupantTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcOccupantTypeEnum = new Int32Array([1, 7, -5]);
let prefixSumAddressIfcOccupantTypeEnum = new Uint32Array([0, 8, 18, 28, 36, 44, 56, 69, 76, 90]);
let slotMapIfcOccupantTypeEnum = new Int32Array([3, 0, 1, 2, 6, 8, 7, 5, 4]);
let encodedDataIfcOccupantTypeEnum = (new TextEncoder()).encode(".LESSOR..ASSIGNEE..ASSIGNOR..LESSEE..TENANT..NOTDEFINED..USERDEFINED..OWNER..LETTINGAGENT.");
let IfcOccupantTypeEnumSearch = new MinimalPerfectHash(gMapIfcOccupantTypeEnum, prefixSumAddressIfcOccupantTypeEnum, slotMapIfcOccupantTypeEnum, encodedDataIfcOccupantTypeEnum);
export { IfcOccupantTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcOccupantTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcOccupantTypeEnumSearch, input, cursor, endCursor);
}
